import { Col, Form, FormInstance, Input, Row } from 'antd'
import {
  useAddOrgDocument,
  useUpdateOrgDocument,
} from 'api/EventCreation/creationStep5'
import { infoMessage } from 'api/global'
import UploadDocument from 'components/global/UploadDocument'
import React, { useEffect, useState } from 'react'
import { eventCommonStore } from 'state/event/eventCommon'
import { myStore } from 'state/store'
import { AddOrgDocsPayload, OrgDocumentResp } from 'types/event/eventStep5'

interface DocumentFormProps {
  form: FormInstance
  organizationId: string
  data: OrgDocumentResp | undefined
  setOpenModal?: React.Dispatch<React.SetStateAction<boolean>>
}

const DocumentForm: React.FC<DocumentFormProps> = ({
  form,
  organizationId,
  data,
  setOpenModal,
}) => {
  const { setAddDocumentModal } = eventCommonStore(store => ({
    setAddDocumentModal: store.setAddDocument,
  }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [documentIds, setDocumentIds] = useState<string[]>([])
  const [documents, setDocuments] = useState<any[]>([])

  const { mutate: orgDocMutate } = useAddOrgDocument()
  const { mutate: updateDoc } = useUpdateOrgDocument()

  const formSchema = {
    name: data ? data.name : undefined,
    description: data ? data.description : undefined,
  }

  const onFinish = (values: AddOrgDocsPayload) => {
    if (documentIds.length === 0) {
      return infoMessage('Document must be added')
    }
    const payload = {
      ...values,
      organizationId,
      isDefault: false,
      fileId: documentIds[0],
    }
    setModalBtnLoader(true)
    if (data) {
      updateDoc(
        { payload, typeId: data._id },
        {
          onSuccess: () => {
            setModalBtnLoader(false)
            setOpenModal(false)
          },
          onError: () => {
            setModalBtnLoader(false)
          },
        },
      )
    } else {
      orgDocMutate(payload, {
        onSuccess: () => {
          setModalBtnLoader(false)
          setAddDocumentModal(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      })
    }
  }

  useEffect(() => {
    if (data) {
      setDocumentIds([data.fileId])
      setDocuments([data.file])
    }
  }, [data])

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        initialValues={formSchema}
        onFinish={onFinish}
      >
        <Row gutter={10}>
          <Col>
            <label className="input-label required-input">Name</label>
            <Form.Item
              className="form-control"
              name="name"
              rules={[{ required: true, message: 'Title is required' }]}
            >
              <Input
                className="question-field"
                placeholder="Enter name of document"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={10}>
          <Col>
            <label className="input-label required-input">Description</label>
            <Form.Item
              className="form-control"
              name="description"
              rules={[{ required: true, message: 'Description is required' }]}
            >
              <Input.TextArea
                className="answer-field"
                placeholder="Enter short description"
                autoSize={{ minRows: 5, maxRows: 8 }}
              />
            </Form.Item>
          </Col>
        </Row>
        <div className="relative">
          <label className="input-label required-input">Upload document</label>
          <UploadDocument
            documentIds={documentIds}
            setDocumentIds={setDocumentIds}
            multiple={false}
            docType=".pdf,.doc,.docx,.txt"
            files={documents}
          />
        </div>
      </Form>
    </>
  )
}

export default DocumentForm
